import { useState } from 'react';
import { autoPlacement, offset, Placement, ReferenceType, useFloating, UseFloatingOptions } from '@floating-ui/react';

export const useNavigableItemPopover = ({
  placement = 'right',
  allowedPlacements = ['right', 'left', 'top', 'bottom'],
}: { placement?: UseFloatingOptions['placement']; allowedPlacements?: Array<Placement> } = {}) => {
  const [showNavigableItemPopover, setShowNavigableItemPopover] = useState(false);
  const { refs, floatingStyles } = useFloating({
    open: showNavigableItemPopover,
    onOpenChange: setShowNavigableItemPopover,
    placement,
    strategy: 'fixed',
    whileElementsMounted: createStablePositioning,
    middleware: [
      offset(8),
      autoPlacement({
        allowedPlacements: allowedPlacements,
      }),
    ],
  });

  return { setShowNavigableItemPopover, showNavigableItemPopover, refs, floatingStyles };
};

const createStablePositioning = (referenceEl: ReferenceType, floatingEl: HTMLElement | null, update: () => void) => {
  const resizeObserver = new ResizeObserver(() => {
    if (referenceEl && 'getBoundingClientRect' in referenceEl && referenceEl instanceof Element) {
      update();
    }
  });

  if (referenceEl && 'getBoundingClientRect' in referenceEl && referenceEl instanceof Element) {
    resizeObserver.observe(referenceEl);
  }

  const scrollHandler = () => update();
  window.addEventListener('scroll', scrollHandler, true);

  return () => {
    resizeObserver.disconnect();
    window.removeEventListener('scroll', scrollHandler, true);
  };
};
